import React from 'react'
import Resx from '@/components/Resx'
import { WhiteBox } from '@/components/Layout'
import { InfoContent } from '@/components/InfoRow'

const ReportSubmissionGroupNotes = ({ reportSubmission }) => {
  if (reportSubmission.notes || reportSubmission.latinNotes) {
    return (
      <Resx render={({ localizeValue }) => <WhiteBox header='Reporting.Notes'>
        <InfoContent className='pre-text'>{localizeValue(reportSubmission.notes, reportSubmission.latinNotes)}</InfoContent>
      </WhiteBox>} />
    )
  }
  return null
}

export {
  ReportSubmissionGroupNotes
}



// WEBPACK FOOTER //
// ./src/components/reporting/reportSubmissionGroupNotes.js